import { WorldForecastSchema } from "@/schemas/world-forecast-schema";

export const findForecastByDateSelected = ({
	forecastData,
	selectedDate,
}: {
	forecastData: WorldForecastSchema;
	selectedDate: Date;
}) => {
	return forecastData.filter((forecast) => {
		return (
			new Date(forecast.timestep).getDate() === new Date(selectedDate).getDate()
		);
	});
};

export const avoidWorldForecastDate = (forecastData: WorldForecastSchema) => {
	const groupedByDate = forecastData
		.filter((data) => new Date(data.timestep).getTime() >= Date.now())
		.reduce<Record<string, WorldForecastSchema>>((acc, item) => {
			const date = new Date(item.timestep).toISOString();

			if (!acc[date]) {
				acc[date] = [];
			}

			acc[date].push(item);

			return acc;
		}, {});

	return Object.entries(groupedByDate).map(([date, items]) => ({
		date,
		items,
	}));
};
